// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-Share----index-module---root---3nJyZ","icon":"src-components-Share----index-module---icon---31_Lp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Share/index.module.css
// module id = 619
// module chunks = 168707334958949